import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

export const INCIDENT_CARD_SIZE = '15rem';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()(theme => ({
  incidentCard: {
    height: '100%',
    width: INCIDENT_CARD_SIZE,
    margin: theme.spacing(1),

    '& button': {
      textIndent: 'inherit',
      padding: '0',
    },
  },

  header: {
    height: '3rem',
    color: theme.palette.common.white,

    '& div:nth-of-type(2)': {
      width: '120%', // there is another div next to it, but nothing is within this div, this is done by MaterialUI and we overwrite this functionality
      justifyContent: 'space-between',
    },
  },

  content: {
    height: '6rem',
    padding: '0.5rem',
    textAlign: 'left',
    whiteSpace: 'pre-wrap',
  },

  chip: {
    margin: 0,
  },

  impactedServices: {
    fontWeight: 'bold',
  },
}));
